/** Базовый адрес бэкенда: от него считаются GraphQL-эндпоинт и REST-ручки файлов. */
export const API_URL = process.env.PUBLIC_API_URL ?? '';

/** GraphQL-эндпоинт для запросов и мутаций. */
export const GRAPHQL_URL = `${API_URL}/graphql`;

/** WebSocket-эндпоинт GraphQL-подписок (протокол graphql-transport-ws). */
export const WS_URL = process.env.PUBLIC_WS_URL ?? '';

/** Адрес админ-панели: пункт «Панель администратора» в меню профиля. Не задан — пункта нет. */
export const ADMIN_URL = process.env.PUBLIC_ADMIN_URL ?? '';
